export const districts = [
  {
    districtId: 1,
    districtName: 'Tvär-/Nockebybanan',
    districtShort: 'BM',
    districtCode: 933,
    division: {
      id: 1,
      name: 'Tåg'
    }
  },
  {
    districtId: 2,
    districtName: 'Saltsjöbanan',
    districtShort: 'NEG',
    districtCode: 934,
    division: {
      id: 1,
      name: 'Tåg'
    }
  },
  {
    districtId: 3,
    districtName: 'Roslagsbanan',
    districtShort: 'RB',
    districtCode: 936,
    division: {
      id: 1,
      name: 'Tåg'
    }
  },
  {
    districtId: 4,
    districtName: 'Pågatågen',
    districtShort: 'PGT',
    districtCode: 0,
    division: {
      id: 1,
      name: 'Tåg'
    }
  },
  {
    districtId: 5,
    districtName: 'Östgötapendeln',
    districtShort: 'ÖG',
    districtCode: 1,
    division: {
      id: 1,
      name: 'Tåg'
    }
  },
  {
    districtId: 17,
    districtName: 'Tåg i Bergslagen',
    districtShort: 'TiB',
    districtCode: 940,
    division: {
      id: 1,
      name: 'Tåg'
    }
  },
  {
    districtId: 18,
    districtName: 'VR Snabbtåg',
    districtShort: 'VRS',
    districtCode: 650,
    division: {
      id: 1,
      name: 'Tåg'
    }
  },
  {
    districtId: 19,
    districtName: 'X-trafik',
    districtShort: 'XT',
    districtCode: 651,
    division: {
      id: 1,
      name: 'Tåg'
    }
  },
  {
    districtId: 21,
    districtName: 'Norrtåg',
    districtShort: 'NT',
    districtCode: 0,
    division: {
      id: 1,
      name: 'Tåg'
    }
  },
  {
    districtId: 22,
    districtName: 'Öresundståg',
    districtShort: 'ÖT',
    districtCode: 0,
    division: {
      id: 1,
      name: 'Tåg'
    }
  }
]
